export default{
    apiKey: "AIzaSyCkUoFdCV4oiu0YoyyA0jZPZRDXmpzqXXo",
    authDomain: "aoe2de-auth.firebaseapp.com",
    databaseURL: "https://aoe2de-auth-default-rtdb.firebaseio.com",
    projectId: "aoe2de-auth",
    storageBucket: "aoe2de-auth.appspot.com",
    messagingSenderId: "179242101785",
    appId: "1:179242101785:web:3d309965716ed1f6820e88",
    measurementId: "G-T9PCW07H8J"
}